import React from 'react';
import { Hero } from './components/Hero';
import { BeforeAfter } from './components/BeforeAfter';
import { BigIdea } from './components/BigIdea';
import { Identify } from './components/Identify';
import { WhatIsIt } from './components/WhatIsIt';
import { Tomos } from './components/Tomos';
import { Bonuses } from './components/Bonuses';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { FloatingCTA } from './components/FloatingCTA';
import { MetaPixel } from './components/MetaPixel';
const FIRST_CTA_ID = 'hero-cta';
export function App() {
  return <main className="w-full bg-[#f7f3ec]" data-id="element-0" data-mp="2wip7h5ruzo6i">
      <MetaPixel data-id="element-1" data-mp="28tw6guwdqq51" />
      <Hero ctaId={FIRST_CTA_ID} data-id="element-2" data-mp="28te198rqp1kz" />
      <BeforeAfter data-id="element-3" data-mp="28sl5f2ubjwhm" />
      <BigIdea data-id="element-4" data-mp="28s30zixi6bym" />
      <Identify data-id="element-5" data-mp="23vkuadim43jn" />
      <WhatIsIt data-id="element-6" data-mp="23w4drynwuzzs" />
      <Tomos data-id="element-7" data-mp="23ujmchww7x65" />
      <Bonuses data-id="element-8" data-mp="23v2rey1g2r2r" />
      <Offer data-id="element-9" data-mp="23t8ea5wf0398" />
      <Guarantee data-id="element-10" data-mp="3ijxnsm94vshs" />
      <Testimonials data-id="element-11" data-mp="3ikha0f5th31m" />
      <FAQ data-id="element-12" data-mp="3iiwg8rrbto4t" />
      <FinalCTA data-id="element-13" data-mp="3ijfx0558q6h9" />

      <footer className="w-full bg-[#2a2438] px-5 py-8 text-center text-white/50" data-id="element-14" data-mp="3ihv22ef0kliv">
        <p className="font-serif-display text-lg text-[#c9b8ea]" data-id="element-15" data-mp="3mjztr7lwj82v">
          Biblioteca de Rituales Aromáticos™
        </p>
        <p className="mt-2 text-xs" data-id="element-16" data-mp="3reltuemj9e7n">
          © {new Date().getFullYear()} · Todos los derechos reservados.
        </p>
      </footer>

      <FloatingCTA triggerId={FIRST_CTA_ID} data-id="element-17" data-mp="2zlld2w2kqak3" />
    </main>;
}